import { configureStore } from '@reduxjs/toolkit';

import { api } from './services';
import { directorApi } from './services/director-api';

export const store = configureStore({
  reducer: {
    [api.reducerPath]:         api.reducer,
    [directorApi.reducerPath]: directorApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(api.middleware)
      .concat(directorApi.middleware),
});
